import axios from 'axios';

let productList = null;
const getProductList = async () => {
  if (productList) {
    return productList;
  }

  // NOTE: app only shows primary listing, thus we use GB region
  const result = await axios
   .get(`${process.env.REACT_APP_DATASPAN_API_URL}/productperformance/eligiblefunds/`)
    .then((response) => response.data)
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      return {
        error: 'Exeption',
      };
    });

  productList = result.sort((a, b) => {
    const textA = a.displayName.toUpperCase();
    const textB = b.displayName.toUpperCase();
    if (textA < textB) {
      return -1;
    }
    if (textA > textB) {
      return 1;
    }
    return 0;
  });

  return productList;
};

const pctChange = (v1, v2) => {
  const diff = v2 - v1;

  return (diff / v1) * 100;
};

const formatDtParam = (date) => {
  const dt = typeof date === 'string' ? new Date(date) : date;
  let month = dt.getMonth() + 1;
  month = month < 10 ? `0${month}` : month;

  let day = dt.getDate();
  day = day < 10 ? `0${day}` : day;

  return `${dt.getFullYear()}-${month}-${day}`;
};

const impliedLeverage = (indexPct, fundPct, extendDecimals) => {
  const result = fundPct / indexPct;
  const decimals = extendDecimals ? 2 : 1;
  if (result === Number.POSITIVE_INFINITY || result === Number.NEGATIVE_INFINITY) {
    return (1).toFixed(decimals);
  }

  return result.toFixed(decimals);
};

const getPerformance = async (params) =>
  axios
    .get(`${process.env.REACT_APP_DATASPAN_API_URL}/productperformance/performance/`, {
      params: {
        ticker: params.ticker,
        startDate: formatDtParam(params.startDate),
        endDate: formatDtParam(params.endDate),
      },
    })
    .then((response) => {
      const resultData = response.data
        .reduce((ac, obj) => {
          let dtEntry = ac.find((x) => x.dt === obj.dt);
          if (!dtEntry) {
            dtEntry = {
              dt: obj.dt,
              entityID: obj.entityID,
            };
            ac.push(dtEntry);
          }
          dtEntry[obj.wtType.replace('Benchmark', 'Index')] = obj.level;
          return ac;
        }, [])
        .filter((x) => !!(x.Fund && x.Index))
        .sort((a, b) => new Date(a.dt) - new Date(b.dt))
        .map((x, index, arr) => {
          const prev = arr[index - 1];
          if (prev) {
            const fundPct = pctChange(prev.Fund, x.Fund);
            const indexPct = pctChange(prev.Index, x.Index);
            return {
              ...x,
              fundPct: fundPct.toFixed(2),
              indexPct: indexPct.toFixed(2),
              // ugly hack for "VIXL LN" - should be removed when product gets deleveraged
              impliedLeverage: impliedLeverage(indexPct, fundPct, x.entityID === 'VIXL LN'),
            };
          }
          return x;
        })
        .map((x, _index, arr) => {
          const first = arr[0];
          return {
            ...x,
            Index: ((x.Index / first.Index) * 100).toFixed(2),
          };
        });
      if (resultData.length > 0) {
        resultData.push({
          Fund: '',
          Index: '',
          dt: 'Period Return',
          fundPct: pctChange(resultData[0].Fund, resultData[resultData.length - 1].Fund).toFixed(2),
          indexPct: pctChange(resultData[0].Index, resultData[resultData.length - 1].Index).toFixed(2),

          impliedLeverage: '',
          StrikeTime: '',
        });
      }

      return resultData;
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      return {
        error: 'Exeption',
      };
    });

const API = {
  getProductList,
  getPerformance,
};

export default API;
